import {_Admin} from "./Admin/_Admin";

export const UsersModulePhotoAlbumsAPI = {
    Admin: _Admin
}